import Dashboard from "../../../common/components/layout/Dashboard";
import Toast from "../../../common/components/ui/toast";
import { ToastProvider } from "../../../common/components/ui/toast/toast.provider";
import CollectorsPage from "./components/table-trafficfines/CollectorsPage";


export function RepossessionReportsCollectors() {
	return (
		<ToastProvider>
			<Dashboard>
				<CollectorsPage />
			</Dashboard>
			<Toast />
		</ToastProvider>
	);
}
